// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JJmf","content":"styles_content__3wDoU","tableWrap":"styles_tableWrap__3ayGD"};